import React from 'react';
import { Crown } from 'lucide-react';
import { BannerContainer } from '../BannerContainer';
import { BannerContent } from '../BannerContent';
import { BannerActions } from '../BannerActions';
import { PlanHighlight } from '../PlanHighlight';
import { FeaturesGrid } from '../FeaturesGrid';
import { BANNER_THEMES, FEATURE_SETS, ACTION_CONFIGS } from '../config/bannerConfig';
import { Zap } from 'lucide-react';

interface TrialExpiredBannerProps {
  onDismiss?: () => void;
  className?: string;
}

export const TrialExpiredBanner: React.FC<TrialExpiredBannerProps> = ({
  onDismiss,
  className
}) => {
  const theme = BANNER_THEMES.trial_expired;
  const features = FEATURE_SETS.trial_expired;
  const actions = ACTION_CONFIGS.trial_expired;

  return (
    <BannerContainer
      variant="gradient"
      theme={theme.theme}
      onDismiss={onDismiss}
      className={className}
    >
      <BannerContent
        layout="centered"
        emoji={theme.emoji}
        emojiAnimation={theme.emojiAnimation}
        title={theme.title}
        description={theme.description}
        titleColor={theme.titleColor}
        descriptionColor={theme.descriptionColor}
      >
        {/* Credits exhausted highlight */}
        <PlanHighlight
          type="exhausted"
          value="Credits Exhausted"
          label="Credits Exhausted"
          sublabel="Continue with a paid plan"
          icon={<Zap className="h-5 w-5" />}
          theme="dark"
        />

        {/* Action buttons */}
        <BannerActions
          primary={{
            ...actions.primary,
            icon: <Crown className="h-5 w-5 mr-2" />,
            onClick: onDismiss
          }}
          secondary={{
            ...actions.secondary,
            onClick: onDismiss
          }}
        />

        {/* Plan benefits preview */}
        <FeaturesGrid 
          features={features}
          variant="dark"
        />
      </BannerContent>
    </BannerContainer>
  );
};